import { Delete } from '@mui/icons-material';
import { Card, IconButton, Tooltip } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { sort } from 'fast-sort';
import { useEstateInputDataFormat_GetAllEstateInputDataFormatsQuery } from 'queries';

import FormSelectField from 'common/form-select-field';
import Spinner from 'common/spinner';
import { NotificationSeverity, showAlert } from 'utils/notification-manager';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    padding: '10px',
    marginTop: '20px',
    backgroundColor: '#EEEEEE',
  },
  inputField: {
    marginTop: '10px',
    width: '300px',
  },
  header: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
}));

type Props = {
  value?: string | null;
  index?: number;
  isDisabled?: boolean;
  errorMessage?: string;
  onDelete?: () => void;
  onChange: (value: string) => void;
};

const RequiredInfoDocItem = ({
  onDelete,
  index,
  errorMessage,
  onChange,
  value,
  isDisabled,
}: Props) => {
  const classes = useStyles();

  const { data: estateInputDataFormatsData, loading: estateInputDataFormatsDataLoading } =
    useEstateInputDataFormat_GetAllEstateInputDataFormatsQuery({
      onError: (error) => {
        showAlert({
          message: 'Error getting all Estate Input Data Formats: ' + error.message,
          severity: NotificationSeverity.ERROR,
        });
      },
    });

  if (!estateInputDataFormatsData || estateInputDataFormatsDataLoading) {
    return <Spinner />;
  }

  const estateInputDataFormats = estateInputDataFormatsData.data || [];

  const estateInputDataFormaDataOptions = sort(
    estateInputDataFormats.map(({ id, name }) => ({
      label: name,
      value: id,
    })),
  ).asc((option) => option.label);

  return (
    <Card className={classes.container}>
      <div className={classes.header}>
        {index && <div className={classes.header}>Item {index + 1}</div>}
        {onDelete && (
          <Tooltip title="Remove" placement="right">
            <IconButton onClick={onDelete}>
              <Delete />
            </IconButton>
          </Tooltip>
        )}
      </div>
      <FormSelectField
        disabled={isDisabled}
        value={value}
        errorMessage={errorMessage}
        onChange={(evt) => onChange(evt.target.value as string)}
        options={estateInputDataFormaDataOptions}
        label="Required Information Format"
      />
    </Card>
  );
};

export default RequiredInfoDocItem;
